import { linkBeuni } from "@/lib/constants";
import logoBeuni from "@/assets/images/beuni-logo-claro.png";

// Rodapé do betracking (início e rastreio): a beuni assina, com o link do site.
export default function Rodape() {
  return (
    <footer className="bg-[#2E1718] text-[#CDBDB0]">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 text-sm sm:flex-row sm:px-6">
        <a href={linkBeuni("rodape_logo")} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-white">
          <img src={logoBeuni} alt="beuni" className="h-6" />
          <span className="h-5 w-px bg-[#5b4546]" aria-hidden="true" />
          <span>
            <strong className="font-semibold text-white">betracking</strong> é uma tecnologia da beuni
          </span>
        </a>
        <a href={linkBeuni("rodape")} target="_blank" rel="noreferrer" className="font-semibold text-[#FFB990] hover:text-white">
          beuni.com.br →
        </a>
      </div>
    </footer>
  );
}
